import axios from 'axios'

let cancel, promiseArr = {}
const CancelToken = axios.CancelToken;

// setting http credentials 
axios.defaults.withCredentials = true;
// interceptors
axios.interceptors.request.use(config => {
  // 發起請求時，取消掉當前正在進行的相同請求
  if (promiseArr[config.url]) {
    promiseArr[config.url]('操作取消')
    promiseArr[config.url] = cancel
  } else {

    promiseArr[config.url] = cancel
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 響應攔截器即異常處理
axios.interceptors.response.use(response => {
  return response
}, error => {

   // console.log(error.response.data.data);
  let message = ''

  if (error && error.response) {

    switch (error.response.status) {
      case 400:
        message = '錯誤請求(400)'
        break;
      case 401:
        message = '未授權，請重新登錄(401)'
        break;
      case 403:
        message = '拒絕訪問(403)'
        break;
      case 404:
        message = '請求錯誤，未找到該資源(404)'
        break;
      case 405:
        message = '請求方法未允許(405)'
        break;
      case 408:
        message = '請求超時(408)'
        break;
      case 500:
        message = '服務器端出錯(500)'
        break;
      case 501:
        message = '網絡未實現(501)'
        break;
      case 502:
        message = '網絡錯誤(502)'
        break;
      case 503:
        message = '服務不可用(503)'
        break;
      case 504:
        message = '網絡超時(504)'
        break;
      case 505:
        message = 'HTTP版本不支持該請求(505)'
        break;
      default:
        message = `連接錯誤${error.response.status}`
    }
  } else {
    message = "連接到服務器失敗"
  }

  return Promise.reject(message + ':' + error.response.data.errors )
})

// 設置默認請求頭
axios.defaults.headers = {
  'X-Requested-With': 'XMLHttpRequest'
}

axios.defaults.timeout = 6000

export default {
  // get
  get(url, params) {
    return new Promise((resolve, reject) => {
      axios.get(
        url, {
          params: params,
          cancelToken: new CancelToken(c => {
            cancel = c
          })
        }).then(res => {
        resolve(res)
      }).catch((error) => {
        resolve(error)
       
      })
    })
  },
  //post
  post(url, param) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url,
        data: param,
        cancelToken: new CancelToken(c => {
          cancel = c
        })
      }).then(res => {
        resolve(res)
      }).catch(e => {
        reject(e)
      })
    })
  },
  postWithHeaders(url, param, headers) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url,
        data: param,
        headers:headers,
        cancelToken: new CancelToken(c => {
          cancel = c
        })
      }).then(res => {
        resolve(res)
      }).catch(e => {
        reject(e)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/api/BaseModule.js